import React from 'react';
import './Home.css';

function Masters() {
  return (
    <div className='HomeBody'>
      <p>Masters Section</p>
      <p>Please select desired option.</p>
    </div>
  );
}

export default Masters;
